import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card-cta',
  templateUrl: './card-cta.component.html',
  styleUrls: ['./card-cta.component.css']
})
export class CardCtaComponent implements OnInit {

  @Input() cardInfo;
  @Input() status;
  @Output() public callToAction = new EventEmitter();
  isProcessing = false;

  cta = {
    cta: null,
    productVariantId: null
  };
  
  constructor() {}

  ngOnInit(): void {
    !this.status? this.status = 'unpaid' : null;
  }

  callToActionButton(){
    this.status = 'processing';
    // Redirect to Shopify after a small delay to show animation
    setTimeout(() => {
      this.cta.cta = 'buy';
      this.cta.productVariantId = this.cardInfo.productVariantId;
      this.callToAction.emit(this.cta);
    }, 1000);
    
  }

  isStatus(status){
    return this.status == status;
  }

}
